<template>
    <div class="pb-5 sm:pb-0">
        <h1 class="text-2xl font-medium text-taupe-800">Profile</h1>
        <div v-if="showPersonalAccessTokensTab" class="mt-4 sm:mt-5">
            <zen-tab-list>
                <zen-tab
                    :active="isGeneral"
                    :to="{ name: 'ProfileDefaultScreen' }"
                    >General</zen-tab
                >
                <zen-tab
                    :active="isPersonalAccessTokens"
                    :to="{ name: 'ProfilePersonalAccessTokensScreen' }"
                    >Personal Access Tokens</zen-tab
                >
            </zen-tab-list>
        </div>
    </div>
</template>

<script>
import { useSessionStore } from '@/stores/session'

export default {
    name: 'ProfileHeaderTabs',
    computed: {
        sessionStore() {
            return useSessionStore()
        },
        showPersonalAccessTokensTab() {
            return (
                this.sessionStore.data?.user?.data
                    ?.personal_access_tokens_enabled !== false
            )
        },
        isGeneral() {
            return this.current == 'general'
        },
        isPersonalAccessTokens() {
            return this.current == 'personal-access-tokens'
        },
    },
    props: ['current'],
}
</script>
